export default function Products() {
  const categories = [
    {
      title: 'Gelato',
      image: 'https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/bb9dcb44-fad5-4717-acc5-9acaa83cf7fe_compressed_DSC05792-3.webp',
      desc: 'Artisan gelato churned fresh daily with the world\'s finest natural ingredients.',
    },
    {
      title: 'Pastries',
      image: 'https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/c1eff31f-7a08-4c9b-a91a-9711db31edf9_compressed_Copy-of-DSC05618.webp',
      desc: 'Buttery, flaky viennoiserie and artisanal pastries baked to golden perfection.',
    },
    {
      title: 'Beverages',
      image: 'https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/d04a0cde-e7d3-4b0d-8d98-a5a447c2e41d_compressed_Screenshot-2026-07-22-013404.webp',
      desc: 'Specialty coffee, tea, and house-crafted beverages to complement every bite.',
    },
  ];

  return (
    <section id="products" className="w-full bg-background-900 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl md:text-5xl text-primary-400 glow-text">
            Our Products
          </h2>
          <div className="w-12 h-[2px] bg-primary-500/50 mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {categories.map((cat) => (
            <div key={cat.title} className="flex flex-col items-center text-center group">
              <div className="relative w-full aspect-[4/5] max-w-[380px] rounded-2xl overflow-hidden mb-8">
                <img
                  src={cat.image}
                  alt={`D'CURE Gelato ${cat.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/60 via-transparent to-transparent"></div>
                <div className="absolute -inset-1 -z-10 bg-primary-500/10 blur-3xl rounded-full opacity-70 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              <h3 className="font-heading text-3xl md:text-4xl text-primary-400 glow-text mb-3">
                {cat.title}
              </h3>
              <p className="font-body text-sm text-foreground-300/80 leading-relaxed max-w-xs mb-6">
                {cat.desc}
              </p>
              <a
                href="#menu"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-block border border-primary-500/40 text-primary-400 font-label text-xs font-semibold tracking-[0.12em] px-7 py-2.5 rounded-full hover:bg-primary-500 hover:text-background-950 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                SEE MORE
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}